export const styles = {
  header: 'tw-flex tw-items-center tw-justify-between tw-mb-3',
  title: 'tw-text-sm tw-font-medium tw-text-neutral-700',
  grid: 'tw-grid tw-grid-cols-2 tw-gap-2',
  emptyState: 'tw-text-neutral-500 tw-text-sm',
  domainCard:
    'tw-flex tw-items-center tw-justify-between tw-p-3 tw-border-solid tw-border tw-border-neutral-200 tw-rounded',
  domainName: 'tw-text-sm tw-font-medium tw-text-neutral-800',
  domainIcon: 'tw-text-neutral-400',
};
